import api from './api'
import type { TenantBranding } from '@/types'

export const companyService = {
  async getSettings() {
    const { data } = await api.get('/company/settings')
    return data.data as TenantBranding
  },

  async updateSettings(payload: Partial<TenantBranding>) {
    const { data } = await api.put('/company/settings', payload)
    return data.data as TenantBranding
  },

  async updateLogo(logoUrl: string) {
    const { data } = await api.put('/company/logo', { logoUrl })
    return data.data as TenantBranding
  },

  async deleteLogo() {
    const { data } = await api.delete('/company/logo')
    return data.data as TenantBranding
  },

  /** Upload a new photo — adds to library and auto-selects it */
  async addCoverPhoto(coverPhotoUrl: string) {
    const { data } = await api.post('/company/cover-photos', { coverPhotoUrl })
    return data.data as TenantBranding
  },

  /** Remove one photo from the library by its URL */
  async deleteOneCoverPhoto(photoUrl: string) {
    const { data } = await api.delete('/company/cover-photos', { data: { photoUrl } })
    return data.data as TenantBranding
  },

  /** Select an existing photo (library or preset) as the active cover */
  async selectCoverPhoto(coverPhotoUrl: string | null) {
    const { data } = await api.put('/company/cover-photo', { coverPhotoUrl })
    return data.data as TenantBranding
  },

  /** @deprecated use addCoverPhoto */
  async uploadCoverPhoto(coverPhotoUrl: string) {
    return this.addCoverPhoto(coverPhotoUrl)
  },

  /** @deprecated use deleteOneCoverPhoto */
  async deleteCoverPhoto() {
    const { data } = await api.delete('/company/cover-photo')
    return data.data as TenantBranding
  },
}
